import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Edit_Category = () => {
  const { id } = useParams(); // Get category ID from URL
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({ test_category: "" });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Fetch existing category details
  useEffect(() => {
    if (!id) return;

    const token = localStorage.getItem("jwt_token");
    fetch(`${API_BASE_URL}api/getCategoryById?tc_id=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.STATUS && data.data) {
          setFormData({ test_category: data.data.test_category });
        } else {
          setErrorMessage("Failed to load category details.");
        }
      })
      .catch(error => {
        console.error("Error fetching category:", error);
        setErrorMessage("Failed to load category.");
      });
  }, [id]);

  // Handle input change
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission (Update category)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await fetch(`${API_BASE_URL}api/updateTestCategory`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`, // Include JWT token if required
        },
        body: JSON.stringify({ tc_id: id, ...formData }),
      });

      if (!response.ok) {
        throw new Error("Failed to update category");
      }

      const data = await response.json();
      console.log("Success:", data);

      setShowSnackbar(true);

      setTimeout(() => {
        setShowSnackbar(false);
        navigate(-1); // Navigate back after update
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Failed to update category. Please try again.");
    }
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page">
        <div className="position-relative">
          <Navbar />
        </div>
        <div className="content-inner container-fluid pb-0" id="page_layout">
          {showSnackbar && (
            <div className="snackbar">
              <p>Test Category updated successfully!</p>
            </div>
          )}

          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">Edit Category</h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="new-user-info">
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label htmlFor="test_category">Category Name:</label>
                          <input
                            type="text"
                            className="form-control form-control-sm my-2"
                            id="test_category"
                            name="test_category"
                            value={formData.test_category}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-danger-subtle"
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-sm btn-primary-subtle">
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Edit_Category;
